//#region src/js/variant.js
var VariantSelects = class extends HTMLElement {
	connectedCallback() {
		if (this.initialized) return;
		this.initialized = true;
		this.addEventListener("change", this.onVariantChange);
		this.updateMedia();
		this.assignClassToNextItem();
	}
	onVariantChange() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, "", false);
		this.removeErrorMessage();
		this.updateVariantStatuses();
		this.updatePickupAvailability();
		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true);
			this.setUnavailable();
		} else {
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
			this.assignClassToNextItem();
		}
	}
	updateOptions() {
		this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
		console.log(this.options);
	}
	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => !variant.options.map((option, index) => this.options[index] === option).includes(false));
	}
	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === "false") return;
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}
	updateVariantInput() {
		document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach((productForm) => {
			const input = productForm.querySelector("input[name=\"id\"]");
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}
	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter((variant) => this.querySelector(":checked").value === variant.option1);
		const inputWrappers = [...this.querySelectorAll("[data-form-input]")];
		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [...option.querySelectorAll("input[type=\"radio\"], option")];
			const prevousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
			const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => variant.available && variant[`option${index}`] === prevousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
	}
	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) input.innerText = input.getAttribute("value");
			else input.innerText = window.variantStrings.unavailable_with_option.replace("[value", input.getAttribute("value"));
		});
	}
	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector("pickup-availability");
		if (!pickUpAvailability) return;
		if (this.currentVariant && this.currentVariant.available) pickUpAvailability.fetchAvailability(this.currentVariant.id);
		else {
			pickUpAvailability.removeAttribute("available");
			pickUpAvailability.innerHTML = "";
		}
	}
	removeErrorMessage() {
		const section = this.closest("section");
		if (!section) return;
		const productForm = section.querySelector("product-form");
		if (productForm) productForm.handleErrorMessage();
	}
	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id;
		fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`).then((response) => response.text()).then((responseText) => {
			if (this.currentVariant.id !== requestedVariantId) return;
			const html = new DOMParser().parseFromString(responseText, "text/html");
			const destination = document.getElementById(`price-${this.dataset.section}`);
			const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
			if (source && destination) destination.innerHTML = source.innerHTML;
			const price = document.getElementById(`price-${this.dataset.section}`);
			if (price) price.classList.remove("visibility-hidden");
			this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldout);
		});
	}
	toggleAddButton(disable = true, text) {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`);
		if (!productForm) return;
		const addButton = productForm.querySelector("[name=\"add\"]");
		const addButtonText = productForm.querySelector("[name=\"add\"] > span");
		if (!addButton) return;
		if (disable) {
			addButton.setAttribute("disabled", "disabled");
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute("disabled");
			addButtonText.textContent = window.variantStrings.addToCart;
		}
	}
	/**
	*
	* Called by the onVariantChange(); and on the first page load
	*/
	updateMedia() {
		const variants = document.querySelectorAll(".variant-selector__option input");
		const images = document.querySelectorAll(".gallery__item");
		const slides = document.querySelectorAll(".slide");
		const selectedVariants = Array.from(variants).filter((input) => input.checked).map((input) => input.getAttribute("data-linked-with"));
		if (slides) slides.forEach(function(slide) {
			const variant = slide.getAttribute("data-variant");
			/**
			* Hides the slides that are not the same with the input value
			*/
			slide.hidden = !(selectedVariants.includes(variant) || variant === "default" && !slide.hasAttribute("data-linked-with"));
		});
		else
 /**
		* Loop over all the product images and makes the connection between the variant and images with the same attribute value
		*/
		images.forEach(function(image) {
			const variant = image.getAttribute("data-variant");
			/**
			* Hides the images that are not the same with the input value
			*/
			image.hidden = !(selectedVariants.includes(variant) || variant === "default" && !image.hasAttribute("data-linked-with") && !image.includes("variant_"));
		});
	}
	assignClassToNextItem() {
		const items = document.querySelectorAll(".slide");
		for (const item of items) if (!item.hasAttribute("hidden")) {
			item.classList.add("big-image");
			break;
		}
	}
	setUnavailable() {
		const button = document.getElementById(`product-form=${this.dataset.section}`);
		const addButton = button.querySelector("[name=\"add\"]");
		const addButtonText = button.querySelector("[name=\"add\"] > span");
		const price = document.getElementById(`price-${this.dataset.section}`);
		const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
		const sku = document.getElementById(`Sku-${this.dataset.section}`);
		if (!addButton) return;
		addButtonText.textContent = window.variantStrings.unavailable;
		if (price) price.classList.add("visibility-hidden");
		if (inventory) inventory.classList.add("visibility-hidden");
		if (sku) sku.classList.add("visibility-hidden");
	}
	getVariantData() {
		this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent);
		return this.variantData;
	}
};
customElements.define("variant-selects", VariantSelects);
var VariantRadios = class extends VariantSelects {
	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) input.classList.remove("disabled");
			else input.classList.add("disabled");
		});
	}
	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll("fieldset"));
		this.options = fieldsets.map((fieldset) => Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value);
	}
};
customElements.define("variant-radios", VariantRadios);
//#endregion
